export default __webpack_public_path__ + "static/media/player.dd5f63ef.png";